<template>
  <b-container style=" border-radius: 15px">
    <HorizontalTopbarInside />
    <b-card style="margin-top: 170px; padding: 0">
      <header class="header">
        <h2
        >{{$t('message.Position_information')}}
        </h2>
      </header>
      <b-row>
        <b-col
            md="6"
            style="font-size: 15px;
            padding-top: 60px">
          <p
              class="font-weight-semibold"
          >{{$t('message.Work_place')}}:
            <span
                class="text"> {{vacancy_application.region.nameuz}}<br>
            {{vacancy_application.rayon.nameuz}} {{vacancy_application.school.organizationfullname}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Rank')}}:
            <span
                class="text">{{vacancy_application.position_level.name}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Salary')}}:
            <span
                class="text">{{vacancy_application.salary}} so'm</span></p>
<!--          <br>-->
<!--          <p-->
<!--              class="font-weight-semibold"-->
<!--          >Stavka:-->
<!--            <span class="text"> 0.25</span></p>-->
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Work_experience')}}:
            <span
                class="text"> {{vacancy_application.work_experience.name}} yil</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Job_number')}}:
            <span
                class="text">{{vacancy_application.vacancy_count}}</span></p>
        </b-col>
        <b-col
            md="6"
            style="font-size: 15px;
            padding-top: 60px">
          <p
              class="font-weight-semibold"
          >{{$t('message.Educational_information')}}:
            <span
                class="text">{{vacancy_application.education.name}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Work_type')}}:
            <span
                class="text">{{vacancy_application.job_type.name}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Form_payment')}}:
            <span
                class="text">{{vacancy_application.payment_type.name}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Workplace_employment')}}:
            <span
                class="text">{{vacancy_application.workplace_employment ? vacancy_application.workplace_employment.name : ''}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Phone_number')}}:
            <span
                class="text">{{vacancy_application.contact_number}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Add_posted')}}:
            <span
                class="text">{{vacancy_application.updated_at | formatDate}}</span></p>
          <br>
          <p
              class="font-weight-semibold"
          >{{$t('message.Submission_deadline')}}:
            <span
                class="text">{{vacancy_application.deadline | formatDate}}</span></p>
        </b-col>
      </b-row>
      <b-button
          size="lg"
          style="background-color: #185d89"
          class="btn text-white"
          @click="handlePush"
      >{{$t('message.Apply')}}</b-button>
    </b-card>
  </b-container>
</template>

<script>
import {showSchoolJob} from "../../../../api/school_job_vacancy";
import moment from 'moment'
import HorizontalTopbarInside from "../../../../components/horizontal-topbar-inside";

export default {
  name: "PositionInformation",
  data(){
    return{
      vacancy_application: null
    }
  },
  components:{
    HorizontalTopbarInside,
  },
  created() {
    this.fetchAllJobs()
  },
  filters:{
    formatDate(val) {
      return moment(val).format('DD-YY-YYYY')
    }
  },
  methods:{
    fetchAllJobs(){
      showSchoolJob(this.$route.params.id).then(response => {
        this.vacancy_application = response.data.data
      })
    },
    handlePush(){
      this.$router.push({name: 'register', params: {vacancyId: this.$route.params.id}})
    }
  },
}
</script>

<style scoped>
h2 {
  text-align: center;
  color: #ffffff;
}
h3 {
  text-align: center;
  color: #ffffff;
}
.btn{
  color:  #185d89;
  margin-left: 450px;
  margin-top: 60px;
}
.header{
  background-color: #185d89;
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 15px
}
span{
  font-weight: normal;
}
</style>
